import { getSidebarValues, setSidebarValues, SidebarValues } from './sidebar';

// eslint-disable-next-line no-restricted-imports
import Storage from 'common/lib/storage';

// eslint-disable-next-line no-restricted-imports
import Token from 'common/lib/util/token';

export const setLocalStorageUser = (idMe = Token.getMyId()) => {
  if (idMe) {
    Storage.set('idMe', idMe);
  }
};

setLocalStorageUser();

export interface LocalStorageValues {
  readonly sidebar: SidebarValues;
}

export const getState = (): LocalStorageValues => {
  return {
    sidebar: getSidebarValues() || ({} as SidebarValues),
  };
};

export const setState = (state: LocalStorageValues) => {
  setSidebarValues(state.sidebar);
};



// WEBPACK FOOTER //
// ./app/gamma/src/util/application-storage/index.ts